export interface Country {
  code: string;
  name: string;
  coordinates: {
    lat: number;
    lng: number;
  };
}

//Note: The coordinates are for capital city
const countries: Country[] = [
  { code: "ao", name: "Angola", coordinates: { lat: -8.839, lng: 13.2894 } }, // Luanda
  { code: "bf", name: "Burkina Faso", coordinates: { lat: 12.3686, lng: -1.5271 } }, // Ouagadougou
  { code: "bw", name: "Botswana", coordinates: { lat: -24.6282, lng: 25.9231 } }, // Gaborone
  { code: "cd", name: "DRC", coordinates: { lat: -4.4419, lng: 15.2663 } }, // Kinshasa
  { code: "cm", name: "Cameroon", coordinates: { lat: 3.848, lng: 11.5021 } }, // Yaoundé
  { code: "cv", name: "Cape Verde", coordinates: { lat: 14.933, lng: -23.5133 } }, // Praia
  { code: "et", name: "Ethiopia", coordinates: { lat: 9.03, lng: 38.74 } }, // Addis Ababa
  { code: "gh", name: "Ghana", coordinates: { lat: 5.6037, lng: -0.187 } }, // Accra
  { code: "gm", name: "Gambia", coordinates: { lat: 13.4549, lng: -16.579 } }, // Banjul
  { code: "gq", name: "Equatorial Guinea", coordinates: { lat: 3.7507, lng: 8.7833 } }, // Malabo
  { code: "ke", name: "Kenya", coordinates: { lat: -1.2864, lng: 36.8172 } }, // Nairobi
  { code: "lr", name: "Liberia", coordinates: { lat: 6.3005, lng: -10.7969 } }, // Monrovia
  { code: "ls", name: "Lesotho", coordinates: { lat: -29.3167, lng: 27.4833 } }, // Maseru
  { code: "mu", name: "Mauritius", coordinates: { lat: -20.1609, lng: 57.5012 } }, // Port Louis
  { code: "mw", name: "Malawi", coordinates: { lat: -13.9626, lng: 33.7741 } }, // Lilongwe
  { code: "mz", name: "Mozambique", coordinates: { lat: -25.9653, lng: 32.5892 } }, // Maputo
  { code: "na", name: "Namibia", coordinates: { lat: -22.5597, lng: 17.0832 } }, // Windhoek
  { code: "ne", name: "Niger", coordinates: { lat: 13.5116, lng: 2.1254 } }, // Niamey
  { code: "ng", name: "Nigeria", coordinates: { lat: 9.0578, lng: 7.4951 } }, // Abuja
  { code: "rw", name: "Rwanda", coordinates: { lat: -1.9441, lng: 30.0619 } }, // Kigali
  { code: "sl", name: "Sierra Leone", coordinates: { lat: 8.4657, lng: -13.2317 } }, // Freetown
  { code: "sn", name: "Senegal", coordinates: { lat: 14.6928, lng: -17.4467 } }, // Dakar
  { code: "st", name: "Sao Tome and principe", coordinates: { lat: 0.3365, lng: 6.7273 } }, // São Tomé
  { code: "tg", name: "Togo", coordinates: { lat: 6.1319, lng: 1.2228 } }, // Lomé
  { code: "tz", name: "Tanzania", coordinates: { lat: -6.7924, lng: 39.2083 } }, // Dodoma
  { code: "ug", name: "Uganda", coordinates: { lat: 0.3476, lng: 32.5825 } }, // Kampala
  { code: "zm", name: "Zambia", coordinates: { lat: -15.3875, lng: 28.3228 } }, // Lusaka
  { code: "zw", name: "Zimbabwe", coordinates: { lat: -17.8292, lng: 31.0522 } }, // Harare

  //The api that returns cities for a country either returns an empty array or gives an
  //error saying that a valid country needs to be used. These seem to be DTH countries.
  { code: "bi", name: "Burundi", coordinates: { lat: -3.3822, lng: 29.3644 } }, // Gitega
  { code: "cf", name: "Central African Republic", coordinates: { lat: 4.3947, lng: 18.5582 } }, // Bangui
  { code: "km", name: "Comoros", coordinates: { lat: -11.6986, lng: 43.2551 } }, // Moroni
  { code: "bj", name: "Benin", coordinates: { lat: 6.3703, lng: 2.3912 } }, // Porto-Novo
  { code: "cg", name: "Congo Brazzaville", coordinates: { lat: -4.2634, lng: 15.2429 } }, // Brazzaville, Republic of Congo
  { code: "ci", name: "Ivory Coast", coordinates: { lat: 5.3453, lng: -4.0244 } }, // Yamoussoukro
  { code: "dj", name: "Djibouti", coordinates: { lat: 11.588, lng: 43.1456 } }, // Djibouti
  { code: "er", name: "Eritrea", coordinates: { lat: 15.3229, lng: 38.9251 } }, // Asmara
  { code: "ga", name: "Gabon", coordinates: { lat: 0.4162, lng: 9.4673 } }, // Libreville
  { code: "gn", name: "Guinea", coordinates: { lat: 9.6412, lng: -13.5784 } }, // Conakry
  { code: "gw", name: "Guinea-Bissau", coordinates: { lat: 11.8817, lng: -15.617 } }, // Bissau
  { code: "mg", name: "Madagascar", coordinates: { lat: -18.8792, lng: 47.5079 } }, // Antananarivo
  { code: "ml", name: "Mali", coordinates: { lat: 12.6392, lng: -8.0029 } }, // Bamako
  { code: "mr", name: "Mauritania", coordinates: { lat: 18.0735, lng: -15.9582 } }, // Nouakchott
  { code: "sc", name: "Seychelles", coordinates: { lat: -4.6191, lng: 55.4513 } }, // Victoria
  { code: "sd", name: "Sudan", coordinates: { lat: 15.5007, lng: 32.5599 } }, // Khartoum
  { code: "so", name: "Somalia", coordinates: { lat: 2.0469, lng: 45.3182 } }, // Mogadishu
  { code: "ss", name: "South Sudan", coordinates: { lat: 4.8594, lng: 31.5713 } }, // Juba
  { code: "sz", name: "Eswatini", coordinates: { lat: -26.3054, lng: 31.1367 } }, // Mbabane
  { code: "td", name: "Chad", coordinates: { lat: 12.1348, lng: 15.0557 } }, // N'Djamena
];

export const findCountryByCode = (code: string) => countries.find(x => x.code === code);

export default countries;
